class ContentGridCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 20,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 2.1,
              spacing: 20,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md +
            1}px)`]: {
            disabled: true,
          },
        },
      },
      [window.BAO.Carousel.useInitialised()],
    )
  }
}

if (!customElements.get('content-grid-carousel')) {
  customElements.define('content-grid-carousel', ContentGridCarousel)
}
